export default {
    "title" : "PR Photography", 
    "admin" : {
        "name" : "ROHIT PODILA", 
        "age" : 1996 , 
        "contact" : {
            "whatsApp" : "+919492393347", 
            "mobile" : "+919492393347",
            "instagram" : "https://www.instagram.com/photographer_pr_/",
            "facebook" : "https://www.facebook.com/PRpodila/" , 
            "email" : "prphotograher57@gmail.com"
        } ,  
        "address" : "Saidabad, Hyderabad, Telangana, 500059, India.",
        "site" : "pr-photography.web.app"
    },
    "about" : "Rohit is a skilled photographer, mastering his art since 6 years. He is an expert in fashion and newborn photography, with an interest towards wildlife photography." ,
    "categories" : ["Traditional" , "Nature" , "nextCatog" ] ,
    "load_limit" : "9"  
}